var _defs, _circle, _path, _circle2, _circle3, _circle4, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#1292ee;}.cls-1,.cls-2{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#0094ef;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50,
    cy: 50,
    r: 47.32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.22,15.56c-2.42.57-16.19,4.03-24.07,17.61-9.64,16.62-1.9,33.69-1.17,35.22,3.46-3.33,6.91-6.65,10.37-9.98"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 31.54,
    cy: 54.19,
    r: 5.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 54.83,
    cy: 22.89,
    r: 5.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 67.74,
    cy: 46.11,
    r: 5.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.09,73.74l4.96-9.38c.66-1.25.74-2.73.21-4.04l-6.51-16.16c-.55-1.38-.44-2.93.31-4.22l7.68-13.16"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.72,41.98l8.61-11.36c.97,1.67,9.19,16.32,2.35,33-6.58,16.04-21.74,20.91-23.74,21.52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnology);
export default __webpack_public_path__ + "static/media/Technology.6a6411cde48c5813b3edab77a08476a0.svg";
export { ForwardRef as ReactComponent };